import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private api: ApiService) {}

  listarUsuarios(_token: string) {
    return this.api.post<{ rows: any[] }>('/users/management/list');
  }

  listarProfiles(_token: string) {
    return this.api.post<{ rows: any[] }>('/users/management/profiles');
  }

  listarSucursales(_token: string) {
    return this.api.post<{ rows: any[] }>('/users/management/branches');
  }

  obtenerUsuarioPorId(_token: string, id: number) {
    return this.api.post<{ row: any | null }>('/users/management/find', {
      id
    }).pipe(
      map(({ row }) => ({ rows: row ? [row] : [] }))
    );
  }

  crearUsuario(_token: string, payload: any) {
    return this.api.post<{ id: number }>('/users/management/create', payload);
  }

  actualizarUsuario(_token: string, id: number, payload: any) {
    return this.api.post<{ id: number }>('/users/management/update', {
      id,
      ...payload
    });
  }

  actualizarEstado(_token: string, id: number, estado: string) {
    return this.api.post<{ id: number }>('/users/management/status', {
      id,
      estado
    });
  }

  eliminarUsuario(_token: string, id: number) {
    return this.api.post<{ id: number }>('/users/management/delete', { id });
  }
}
